export default __webpack_public_path__ + "static/127-e03ea1b73c9b6b7024e05d7573140fc2.jpg";